__turbopack_context__.v({
  "decision": "homepage-test-studio-module__sgJQ1q__decision",
  "demo": "homepage-test-studio-module__sgJQ1q__demo",
  "diagram": "homepage-test-studio-module__sgJQ1q__diagram",
  "distance": "homepage-test-studio-module__sgJQ1q__distance",
  "distanceNote": "homepage-test-studio-module__sgJQ1q__distanceNote",
  "distanceScale": "homepage-test-studio-module__sgJQ1q__distanceScale",
  "endpoint": "homepage-test-studio-module__sgJQ1q__endpoint",
  "exampleSelect": "homepage-test-studio-module__sgJQ1q__exampleSelect",
  "flow": "homepage-test-studio-module__sgJQ1q__flow",
  "flowNumber": "homepage-test-studio-module__sgJQ1q__flowNumber",
  "flows": "homepage-test-studio-module__sgJQ1q__flows",
  "intro": "homepage-test-studio-module__sgJQ1q__intro",
  "join": "homepage-test-studio-module__sgJQ1q__join",
  "json": "homepage-test-studio-module__sgJQ1q__json",
  "metrics": "homepage-test-studio-module__sgJQ1q__metrics",
  "note": "homepage-test-studio-module__sgJQ1q__note",
  "photo": "homepage-test-studio-module__sgJQ1q__photo",
  "photoBranch": "homepage-test-studio-module__sgJQ1q__photoBranch",
  "photos": "homepage-test-studio-module__sgJQ1q__photos",
  "representStep": "homepage-test-studio-module__sgJQ1q__representStep",
  "representation": "homepage-test-studio-module__sgJQ1q__representation",
  "result": "homepage-test-studio-module__sgJQ1q__result",
  "resultHeader": "homepage-test-studio-module__sgJQ1q__resultHeader",
  "reveal": "homepage-test-studio-module__sgJQ1q__reveal",
  "saved": "homepage-test-studio-module__sgJQ1q__saved",
  "signal": "homepage-test-studio-module__sgJQ1q__signal",
  "stepLabel": "homepage-test-studio-module__sgJQ1q__stepLabel",
  "threshold": "homepage-test-studio-module__sgJQ1q__threshold",
  "transform": "homepage-test-studio-module__sgJQ1q__transform",
  "vector": "homepage-test-studio-module__sgJQ1q__vector",
  "vectorGrid": "homepage-test-studio-module__sgJQ1q__vectorGrid",
  "vectorLabel": "homepage-test-studio-module__sgJQ1q__vectorLabel",
  "vectorValues": "homepage-test-studio-module__sgJQ1q__vectorValues",
  "workspace": "homepage-test-studio-module__sgJQ1q__workspace",
});
